//

import {
  NO_PRINTS,
  STEP,
} from 'modules/v2/pages/Dentist/OrderGuideModal/publish/editor/CheckoutForm/constants';
import { fixValue } from 'modules/v2/pages/Dentist/OrderGuideModal/publish/editor/CheckoutForm/utils';

import S from './styles';

const CreditsNumericInput = ({
  name,
  credits,
  field,
  setFieldValue,
  disabled,
  'data-testid': dataTestId,
}) => {
  const handleChange = (newValue) => {
    if (newValue !== '') {
      setFieldValue(name, fixValue(newValue, field.value, credits));
    }
  };

  return (
    <S.StyledInput
      min={NO_PRINTS}
      max={credits}
      value={field && field.value}
      onChange={handleChange}
      disabled={disabled}
      step={STEP}
      size="large"
      data-testid={dataTestId}
    />
  );
};

export default CreditsNumericInput;
